import { useState } from 'react';
import { denormalisedResponseEntities } from '../../../util/data';

export const useUpdatePersonalData = () => {
  const [isLoading, setLoading] = useState(false);
  const onUpdateProfile = values => {
    setLoading(true);
    const queryParams = {
      expand: true,
      include: ['profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    };

    return window?.app?.sdk.currentUser
      .updateProfile(values, queryParams)
      .then(response => {
        const entities = denormalisedResponseEntities(response);
        if (entities.length !== 1) {
          throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
        }
        const currentUser = entities[0];

        // Update current user in state.user.currentUser through user.duck.js
        return currentUser;
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return { onUpdateProfile, isLoading };
};
